<div class="authentification page_login ">
  <div class="wrapper row d-lg-flex">
    <div class="col-lg-6" style="padding: 48px 156px 20px 156px; background-color: #fff !important;">
      <div class="w-desktop">
        <div class="row head" style="margin-bottom: 160px;">
          <a href="/"><img src="../../../assets/images/conversell-logo.png" alt="Conversell"></a>
        </div>
        <div class=" pr-2 mx-auto mt-3">
          <h1>Reset your password</h1>
          <span class="descTitle">Please enter your email to reset your password. </span>
          <form novalidate [formGroup]="forgetForm" class="card_design" (ngSubmit)="submitted = true">
            <div class="form-group">
              <label class="Label__Text">Email Address</label>
              <div>
                <input pInputText formControlName="email" placeholder="Enter your email" required>
              </div>
              <mat-error *ngIf="submitted && forgetForm.controls['email'].hasError('required') ">
                email is required
              </mat-error>
              <mat-error *ngIf="submitted && forgetForm.controls['email'].hasError('email') ">
                your email is invalid !
              </mat-error>
            </div>
            <div class="form-group">
              <div class="btn-1">
                <button (click)="resetPassword()" class="d-block w-100">Reset password</button>
              </div>
            </div>


            <div class="loginDescription mt-3 text-center">
              <span class="sign-up">Already have an account? </span><a routerLink="/auth/login">Log in</a>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-lg-6 text-lg-end">
      <img src="../../../../../assets/images/screen_mockup.png" alt="">
    </div>
  </div>